import script from "./MfBucket.vue?vue&type=script&setup=true&lang=js"
export * from "./MfBucket.vue?vue&type=script&setup=true&lang=js"

import "./MfBucket.vue?vue&type=style&index=0&id=67c3d740&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67c3d740"]])

export default __exports__